import {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import pen from '../../../images/managers/pen.png';
import plus from '../../../images/managers/plus-purple.svg';

const Refund = ({ onClick, isFuture }) => {
    const { t } = useTranslation();
    const [data, setData] = useState({});

    useEffect(() => {
        setData({
            tooltipText: isFuture ? t('reports.refund.future.tooltip') : t('reports.refund.tooltip'),
            icon: isFuture ? plus : pen
        })
    }, [isFuture]);

    return (
        <>
            <OverlayTrigger
                placement="top"
                overlay={props => (
                    <Tooltip {...props}>
                        {data.tooltipText}
                    </Tooltip>
                )}
            >
                <img src={data.icon} alt="refund" className={`action-icon ${isFuture ? 'future' : ''}`} onClick={onClick} />
            </OverlayTrigger>
        </>
    );
};

export default Refund;